function Filter() {
    this.ajax = new Ajax();
}
Filter.prototype.initAll = function () {
    this.initPagination();
    this.initSortBy();
    this.initView();
    this.initProductTag();
}
Filter.prototype.initPagination = function () {
    var self = this;
    $(".pagination span a").click(function (e) {
        var href = $(this).attr("href");
        var page = href.match(/page=\d+/g);
        if (page) {
            Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
            if (Shopify.queryParams.page) {
                var newurl = self.ajax.filterCreateUrl();
                history.pushState({
                    param: Shopify.queryParams
                }, newurl, newurl);
                self.ajax.loadData(newurl, self.renderProductList.bind(self));
            }
            $("body,html").animate({
              scrollTop: 400
            }, 600)
        }
        e.preventDefault();
    });
}
Filter.prototype.initSortBy = function () {
    var self = this;
    $(".nt-collection-toolbar .form-horizontal #SortBy").change(function (e) {
        var sortType = $(this).val();
        Shopify.queryParams.sort_by = sortType;
        self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        e.preventDefault();
    });
}
Filter.prototype.initView = function () {
    var self = this;
    $(".collection-view button").click(function (e) {
        if (!$(this).hasClass(".change-view--active")) {
            var paging = $(".pagination .page.current").html();
            Shopify.queryParams.view = $(this).attr('data-view');
            self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        }
        e.preventDefault();
    });
}
Filter.prototype.initProductTag = function () {
    var self = this;
    $(".filter-block .filter-content input").click(function (e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }
        var parent = $(this).parents('.filter-block');
        var valueOldTag = parent.find('input[checked]').val();
        var value = $(this).parent().find('input').val();
        var tagPosition = currentTags.indexOf(value);
        if (tagPosition >= 0) {
            currentTags.splice(tagPosition, 1);
        } else {
            currentTags.push(value);
        }
        var oldTagPosition = currentTags.indexOf(valueOldTag);
        if (oldTagPosition >= 0) {
            currentTags.splice(oldTagPosition, 1);
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        e.preventDefault();
    });
    $(".filter-block .filter-title .clear-all").click(function (e) {
        delete Shopify.queryParams.constraint;
        self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        e.preventDefault();
    });
}
Filter.prototype.initViewMoreTagsBlock = function () {
    $('.block-tags .nt-sidebar-content ul').attr('style', 'height: 210px; overflow: hidden;')
 $('.block-tags .nt-sidebar-content').append('<a href="#" class="more-tags">' + 'View more' + '</a>')
    $('a.more-tags').click(function (e) {
        e.preventDefault();
        if ($(this).text() == 'View more') {
            $('.block-tags .nt-sidebar-content ul').removeAttr('style')
            $(this).text('Less')
            return;
        } else if ($(this).text() == 'Less') {
            $('.block-tags .nt-sidebar-content ul').attr('style', 'height: 210px; overflow: hidden;')
            $(this).text('View more')
        }
    })
}
Filter.prototype.initLoadMore = function (className) { 
    window.ias = jQuery.ias({
        container: '.' + className,
        item: '.grid__item',
        pagination: '.' + className + ' .pagination',
        next: '.next a'
    });
    
		window.iasTrigger = new IASTriggerExtension({
            html: '<div class="ias_trigger" style=""><a>' + 'Load more' + '</a></div>'
        })
        window.ias.extension(window.iasTrigger);
    
    window.ias.extension(new IASSpinnerExtension({}));
    var itemLength = 0;
    window.ias.on('render', function () {
        itemLength = $(".nt-des-top").length;
    })
    window.ias.on('rendered', function (items) {
        var imageShopify = new ImageShopify();
        imageShopify.initImageConfigure(items);
        var countDownShopify = new CountDownShopify();
        countDownShopify.initAll(items);
        var cart = new Cart();
        cart.initAddToCart(items);
        var wishlist = new Wishlist();
        wishlist.initAddToWishList(items);
        var compare = new Compare();
        compare.initAddToCompare(items);
        var currentClassName = $(".nt-collection-content > div")[1].className;
        setTimeout(function () {
            if(currentClassName === 'nt-product-grid'){
                imageShopify.initSetProductHeightLoadMore(itemLength - 1);
            }else{
                imageShopify.initSetProductHeight();
            }
        }, 420);
    })
}
Filter.prototype.renderProductList = function (data, callback) {
    var classNameCurrentList = $(".nt-collection-content > div")[1].className;
    var classNameNewList = $(data).find(".nt-collection-content > div")[1].className;
    var currentList = $(".nt-collection-content ." + classNameCurrentList);
    var newList = $(data).find(".nt-collection-content ." + classNameNewList);
    currentList.toggleClass(classNameCurrentList, classNameNewList);
    currentList.replaceWith(newList);
    var currentPaging = $(".nt-collection-content > .pagination");
    var newPaging = $(data).find(".nt-collection-content > .pagination");
    if (currentPaging.length > 0) {
        if (newPaging.length > 0) {
            currentPaging.replaceWith(newPaging);
        } else {
            currentPaging.remove();
        }
    } else {
        if (newPaging.length > 0) {
            $(".nt-collection-content").append(newPaging);
        }
    }
    var currentPagingToolbar = $(".nt-collection-content .nt-collection-toolbar .pagination");
    var newPagingToolbar = $(data).find(".nt-collection-content .nt-collection-toolbar .pagination");
    if (currentPagingToolbar.length > 0) {
        if (newPagingToolbar.length > 0) {
            currentPagingToolbar.replaceWith(newPagingToolbar);
        } else {
            currentPagingToolbar.remove();
        }
    } else {
        if (newPagingToolbar.length > 0) {
            $(".nt-collection-content .nt-collection-toolbar").append(newPagingToolbar);
        }
    }
    this.initPagination();
    var currentSortByToolbar = $(".nt-collection-toolbar #SortBy");
    var newPageSortByToolbar = $(data).find(".nt-collection-toolbar #SortBy");
    currentSortByToolbar.replaceWith(newPageSortByToolbar);
    this.initSortBy();
    var currentViewToolbar = $(".nt-collection-toolbar .collection-view");
    var newPageViewToolbar = $(data).find(".nt-collection-toolbar .collection-view");
    currentViewToolbar.replaceWith(newPageViewToolbar);
    this.initView();
    var currentTagFilter = $('.block-product-filters > .nt-sidebar-content');
    var newTagFilter = $(data).find('.block-product-filters > .nt-sidebar-content');
    currentTagFilter.replaceWith(newTagFilter);
    this.initProductTag();
    var currentTagsBlock = $('.block-tags');
    var newTagsBlock = $(data).find('.block-tags');
    currentTagsBlock.replaceWith(newTagsBlock);
    this.initViewMoreTagsBlock();
    var countDownShopify = new CountDownShopify();
    countDownShopify.initAll();
    var imageShopify = new ImageShopify();
    imageShopify.initImageConfigure();
    imageShopify.initSetProductHeight();
    var cart = new Cart();
    cart.initAddToCart();
    var wishlist = new Wishlist();
    wishlist.initAddToWishList();
    var compare = new Compare();
    compare.initAddToCompare();
    if (window.ias) {
        window.ias.reinitialize();
        window.ias.itemsContainerSelector = '.' + classNameNewList;
        window.ias.paginationSelector = '.' + classNameNewList + ' .pagination';
        if (window.iasTrigger && window.iasTrigger.$triggerNext) {
            window.iasTrigger.$triggerNext.remove();
            window.iasTrigger.$triggerNext = null;
        }
    }
}
